import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0f218a7e"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "nav-margin"
}, null, -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_field = _resolveComponent("van-field");
  const _component_van_col = _resolveComponent("van-col");
  const _component_van_button = _resolveComponent("van-button");
  const _component_van_row = _resolveComponent("van-row");
  const _component_van_cell = _resolveComponent("van-cell");
  const _component_van_cell_group = _resolveComponent("van-cell-group");
  const _component_ListViewCpt = _resolveComponent("ListViewCpt");
  const _component_PopupDatePickerCpt = _resolveComponent("PopupDatePickerCpt");
  const _component_PageNavBackLayoutCpt = _resolveComponent("PageNavBackLayoutCpt");
  return _openBlock(), _createBlock(_component_PageNavBackLayoutCpt, {
    class: "synthetical-commission-page"
  }, {
    default: _withCtx(() => [_createVNode(_component_van_row, null, {
      default: _withCtx(() => [_createVNode(_component_van_col, {
        span: "10"
      }, {
        default: _withCtx(() => [_createVNode(_component_van_field, {
          modelValue: $data.searchForm.startDate,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.searchForm.startDate = $event),
          readonly: "",
          clickable: "",
          name: "startDate",
          placeholder: "开始日期",
          onClick: _cache[1] || (_cache[1] = $event => $options.onPopupDateTimeSelectClick('startDate'))
        }, null, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_van_col, {
        span: "10"
      }, {
        default: _withCtx(() => [_createVNode(_component_van_field, {
          modelValue: $data.searchForm.endDate,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.searchForm.endDate = $event),
          readonly: "",
          clickable: "",
          name: "endDate",
          placeholder: "结束日期",
          onClick: _cache[3] || (_cache[3] = $event => $options.onPopupDateTimeSelectClick('endDate'))
        }, null, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_van_col, {
        span: "4"
      }, {
        default: _withCtx(() => [_createVNode(_component_van_button, {
          plain: "",
          style: {
            "width": "100%"
          },
          type: "primary",
          loading: $data.btnLoading,
          onClick: $options.onSearch
        }, {
          default: _withCtx(() => [_createTextVNode(" 查询 ")]),
          _: 1
        }, 8, ["loading", "onClick"])]),
        _: 1
      })]),
      _: 1
    }), _createVNode(_component_ListViewCpt, {
      ref: "ListViewCpt",
      request: $data.listRequest,
      requestParameter: $data.searchForm,
      onOnListDataChange: $options.onListDataChange
    }, {
      default: _withCtx(({
        item
      }) => [_hoisted_1, _createVNode(_component_van_cell_group, {
        title: item.agentName + '(' + item.year + '年' + item.month + '月)'
      }, {
        default: _withCtx(() => [_createVNode(_component_van_cell, {
          title: "财富业务费",
          value: item.commission,
          "is-link": "",
          onClick: $event => $options.toURL('财富业务费明细', item)
        }, null, 8, ["value", "onClick"]), _createVNode(_component_van_cell, {
          title: "财富管理奖金",
          value: item.manageBonus,
          "is-link": "",
          onClick: $event => $options.toURL('财富管理奖金明细', item)
        }, null, 8, ["value", "onClick"]), _createVNode(_component_van_cell, {
          title: "保险业务费",
          value: item.insCommission,
          "is-link": "",
          onClick: $event => $options.toURL('保险业务费明细', item)
        }, null, 8, ["value", "onClick"]), _createVNode(_component_van_cell, {
          title: "保险管理奖金",
          value: item.insManageBonus,
          "is-link": "",
          onClick: $event => $options.toURL('保险管理奖金明细', item)
        }, null, 8, ["value", "onClick"]), _createVNode(_component_van_cell, {
          title: "英才奖&超额英才奖",
          value: item.eliteBonus,
          "is-link": "",
          onClick: $event => $options.toURL('英才奖&超额英才奖明细', item)
        }, null, 8, ["value", "onClick"]), _createVNode(_component_van_cell, {
          title: "加扣款",
          value: item.extraCommission,
          "is-link": "",
          onClick: $event => $options.toURL('加扣款明细', item)
        }, null, 8, ["value", "onClick"]), _createVNode(_component_van_cell, {
          title: "特别激励奖",
          value: item.inspireBonus,
          "is-link": "",
          onClick: $event => $options.toURL('特别激励奖明细', item)
        }, null, 8, ["value", "onClick"]), _createVNode(_component_van_cell, {
          title: "合计",
          value: item.totalCommission
        }, null, 8, ["value"])]),
        _: 2
      }, 1032, ["title"])]),
      _: 1
    }, 8, ["request", "requestParameter", "onOnListDataChange"]), _createVNode(_component_PopupDatePickerCpt, {
      ref: "PopupDatePickerCpt",
      columnsType: ['year', 'month'],
      onOnSelectedChange: $options.onDateTimeSelectedChange
    }, null, 8, ["onOnSelectedChange"])]),
    _: 1
  });
}